function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/`;
}

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

function reportInputValidity(input, errorBlock) {
  if (!input || !errorBlock) return false;

  const type = input.type;
  const value = input.value.trim();
  let isValid = true;
  let errorType = "empty";

  isValid = value === "" ? false : true;

  switch (type) {
    case "email":
      if (value !== "" && !input.checkValidity()) {        
        isValid = false;
        errorType = "email"
      }
      break;
  }

  if (isValid) {
    input.removeAttribute("aria-invalid");
    errorBlock.innerText = "";
  } else {
    input.setAttribute("aria-invalid", true);
    errorBlock.innerText = window.errorStrings[errorType];
  }

  return isValid;
}

class Header {
  constructor(root) {
    this.root = root;
    this.mobileMenu = this.root.querySelector("#MobileMenu");
    this.allAnnouncementsHeight = 0;
    this.isLoading = false;

    this.root.addEventListener('click', this.onClick.bind(this));
    
    this.calcHeader();
    window.addEventListener('scroll', () => {
      this.root.classList.toggle('sticky', window.scrollY >= this.allAnnouncementsHeight);
    });
  }
  
  calcHeader() {
		const headerObserver = new ResizeObserver(() => {
			this.headerHeight = this.root.getBoundingClientRect().height;
			document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);

      const announcements = document.querySelectorAll(".announcement");
      this.allAnnouncementsHeight = Math.max(Array.from(announcements).reduce((sum, el) => {
        return sum + el.offsetHeight;
      }, 0), 1);
      
      this.root.classList.toggle('sticky', window.scrollY >= this.allAnnouncementsHeight);
		});

		headerObserver.observe(this.root);
	}

  onClick(event) {
    if (event.target.hasAttribute("data-action")) {
      switch (event.target.dataset.action) {
        case "menu-toggle":
          this.root.classList.toggle("open");
          if (document.documentElement.style.overflow === "hidden") {
            document.documentElement.style.overflow = null;
          } else {
            document.documentElement.style.overflow = "hidden";
          }
          break;
        case "menu-close":
          this.root.classList.remove('open');
          document.documentElement.style.overflow = null;
          break;;
      }
    }
  }
}

if (document.querySelector("header")) {
  new Header(document.querySelector("header"))
}

class FeaturedProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.dataset.type == "recommendations") {
      this.setRecommendationProducts();
    }
  }

  setRecommendationProducts() {
    const recommendationLink = window.Shopify.routes.root + `recommendations/products?limit=8&product_id=${this.dataset.product}&intent=${this.dataset.recommendations}&section_id=${this.dataset.section}`;
      fetch(recommendationLink)
      .then(response => response.text())
      .then(response => {
        const html = new DOMParser().parseFromString(response, "text/html");

        if (html.querySelector("featured-products[data-empty]")) {
          this.style.display = "none";
          return;
        }
        
        const grid = this.querySelector('[id^="Slider-"]');
        grid.innerHTML = html.querySelector('[id^="Slider-"]').innerHTML;

        this.querySelector("slider-component").update();
      })
      .catch(error => console.error(error))
  }
}

if (document.querySelector("featured-products")) {
  customElements.define("featured-products", FeaturedProduct);
}

class MainProduct extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
  }

  connectedCallback() {
    this.productVariants = JSON.parse(this.querySelector("[data-dynamic-variants]").textContent);
    this.cart = document.querySelector("cart-drawer");
    this.gallery = this.querySelector('[id^="ProductGallery-"] slider-component');
    this.navGallery = this.querySelector('[id^="ProductGalleryNav-"]');

    this.querySelector('[id^="ProductOptions-"]')?.addEventListener("change", this.onVariantChange.bind(this));
    this.querySelector('[id^="ProductForm-"]')?.addEventListener("submit", this.onFormSubmit.bind(this));
    this.initClickListeners();
  }

  onVariantChange() {
    if (this.isLoading) return;

    this.toggleLoading();

    const searchParams = new URLSearchParams();
    let selectedValuesLabel = '';

    [1, 2, 3].forEach(option => {
      if (this.querySelector(`[data-option="${option}"]`)) {
        if (this.querySelector(`[data-option="${option}"] input:checked`)) {
          selectedValuesLabel += ' / ' + this.querySelector(`[data-option="${option}"] input:checked`).value;
        } else {
          selectedValuesLabel += ' / ' + this.querySelector(`[data-option="${option}"] input`).value;
        }
      }
    });

    this.productVariants.forEach(variant => {
      if (variant.title === selectedValuesLabel.slice(3)) {
        if (this.querySelector("input[name='id']")) {
          this.querySelector("input[name='id']").value = variant.id;
        }
        searchParams.set('variant', variant.id);
      }
    })

    const newProductUrl = window.location.origin + window.location.pathname + `?${searchParams.toString()}`;
    window.history.replaceState({}, '', newProductUrl);

    fetch(newProductUrl)
    .then(res => res.text())
    .then(body => {
      const html = new DOMParser().parseFromString(body, "text/html");

      this.renderContent(html);
    })
    .catch(error => this.showError(error))
    .finally(() => this.toggleLoading())
  }

  onFormSubmit(event = false) {
    if (event) event.preventDefault();

    if (this.isLoading) return;

    const sections = [];
    if (this.cart) sections.push("cart-drawer");

    const cartData = {
      items: [
        {
          id: parseInt(this.querySelector("[name='id']").value),
          quantity: parseInt(this.querySelector("[name='quantity']").value),
          selling_plan: parseInt(this.querySelector("[name='selling_plan']").value)
        }
      ],
      sections: sections,
      sections_url: window.location.pathname
    };

    this.addToCart(cartData);
  }

  addToCart(data) {
    if (!data) return;

    this.toggleLoading();

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then(response => {
      if (!response.items) {
        const error = new Error(response.description);
        throw error;
      } else {
        this.toggleLoading();
        
        if (this.cart) {
          this.cart.renderContent(response.sections);
          this.cart.open();
        }
      }
    })
    .catch(error => this.showError(error))
    .finally(() => this.toggleLoading(true));
  }

  renderContent(html) {
    const section = html.querySelector(`[data-section="${this.dataset.section}"]`);
    const selectors = ['[id^="ProductPrice-"]', '[id^="ProductOptions-"]', '[id^="ProductSubmit-"]'];

    selectors.forEach(selector => {
      const currentSelectors = this.querySelectorAll(selector);
      const newSelectors = section.querySelectorAll(selector);

      if (currentSelectors.length > 0 && currentSelectors.length == newSelectors.length) {
        currentSelectors.forEach((currentSelector, i) => {
          currentSelector.innerHTML = newSelectors[i].innerHTML;
        })
      }
    });

    if (this.querySelector('[id^="ProductSubmit-"]')) {
      const currentButton = this.querySelector('[id^="ProductSubmit-"]');
      const newButton = section.querySelector('[id^="ProductSubmit-"]');
      currentButton.toggleAttribute("disabled", newButton.disabled);
    }
  }

  initClickListeners() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-action")) {
        switch (e.target.dataset.action) {
          case "change-slide":
            this.gallery.scrollToSlide(parseInt(e.target.dataset.slide));
            break;
        }
      }
    })

    this.addEventListener("slider-updated", (e) => {
      this.navGallery.querySelectorAll("li").forEach(slide => {
        slide.classList.toggle("active", slide.dataset.slide == e.detail.currentSlide)
      })
    })

    this.addEventListener("subscription-submit", () => {
      this.onFormSubmit();
    })
  }

  showError(error) {
    console.error(error);

    if (!this.querySelector("[product-notification]")) return;

    const messageBlock = this.querySelector("[product-notification]");

    messageBlock.innerText = error.message;
    setTimeout(() => {messageBlock.innerText = ''}, 5000);
    messageBlock.scrollIntoView({behavior: "smooth",block:"center"});
  }

  toggleLoading(turnOff = false) {
    this.isLoading = !this.isLoading;
    if (turnOff) this.isLoading = false;
    this.classList.toggle("loading", this.isLoading);
  }
}

if (document.querySelector("main-product")) {
  customElements.define("main-product", MainProduct);
}

class SingleProduct extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
  }

  connectedCallback() {
    this.cart = document.querySelector("cart-drawer");

    this.initClickListeners();
  }

  onFormSubmit(event = false) {
    if (event) event.preventDefault();

    if (this.isLoading) return;

    const currentForm = this.querySelector("[data-product].active form");

    const sections = [];
    if (this.cart) sections.push("cart-drawer");

    const cartData = {
      items: [
        {
          id: parseInt(currentForm.querySelector("[name='id']").value),
          quantity: parseInt(currentForm.querySelector("[name='quantity']").value),
          selling_plan: parseInt(currentForm.querySelector("[name='selling_plan']").value)
        }
      ],
      sections: sections,
      sections_url: window.location.pathname
    };

    this.addToCart(cartData);
  }

  addToCart(data) {
    if (!data) return;

    this.toggleLoading();

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then(response => {
      if (!response.items) {
        const error = new Error(response.description);
        throw error;
      } else {
        this.toggleLoading();
        
        if (this.cart) {
          this.cart.renderContent(response.sections);
          this.cart.open();
        }
      }
    })
    .catch(error => this.showError(error))
    .finally(() => this.toggleLoading(true));
  }

  initClickListeners() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-action")) {
        switch (e.target.dataset.action) {
          case "change-slide":
            e.target.closest("slider-component").scrollToSlide(parseInt(e.target.dataset.slide));
            break;
          case "toggle-product":
            const productId = e.target.dataset.product;

            this.querySelectorAll("[data-product].active").forEach(productBlock => {
              productBlock.classList.remove("active");
            })

            this.querySelectorAll(`[data-product="${productId}"]`).forEach(productBlock => {
              productBlock.classList.add("active");
            })

            this.querySelector("[data-product].active slider-component").update();
            break;
        }
      }
    })

    this.addEventListener("slider-updated", (e) => {
      const navGallery = e.target.querySelector('[id^="ProductGalleryNav-"]');

      navGallery.querySelectorAll("li").forEach(slide => {
        slide.classList.toggle("active", slide.dataset.slide == e.detail.currentSlide)
      })
    })

    this.addEventListener("subscription-submit", () => {
      this.onFormSubmit();
    })
  }

  showError(error) {
    console.error(error);

    const currentForm = this.querySelector("[data-product].active form");

    if (!currentForm.querySelector("[product-notification]")) return;

    const messageBlock = currentForm.querySelector("[product-notification]");

    messageBlock.innerText = error.message;
    setTimeout(() => {messageBlock.innerText = ''}, 5000);
    messageBlock.scrollIntoView({behavior: "smooth",block:"center"});
  }

  toggleLoading(turnOff = false) {
    this.isLoading = !this.isLoading;
    if (turnOff) this.isLoading = false;
    this.classList.toggle("loading", this.isLoading);
  }
}

if (document.querySelector("single-product")) {
  customElements.define("single-product", SingleProduct);
}

class SliderComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.currentSlide = 1;
    this.allowEvents = this.getAttribute("data-allow-events") === "true";
    this.hideControls = this.getAttribute("data-hide-controls") !== "false"

    this.slider = this.querySelector('[id^="Slider-"]');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    this.scrollbar = this.querySelector("[slider-scrollbar]");
    this.scrollbarThumb = this.querySelector("[slider-scrollbar] span");

    this.pagination = this.querySelector('[slider-pagination]');

    if (!this.slider) return;

    this.update();
    window.addEventListener('resize', this.update.bind(this));
    this.slider.addEventListener('scroll', this.update.bind(this));

    if (this.prevButton && this.nextButton) {
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    if (this.pagination) {
      this.pagination.addEventListener("click", this.onDotClick.bind(this))
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    if (event.currentTarget.name === 'previous' && this.currentSlide > 1) {
      this.currentSlide -= 1;
    } else if (event.currentTarget.name === 'next' && this.currentSlide < this.maxLength) {
      this.currentSlide += 1;
    }
    this.scrollToSlide(this.currentSlide);
  }

  onDotClick(event) {
    event.preventDefault();
    if (!event.target.hasAttribute("data-slide")) return;

    const slideIndex = parseInt(event.target.dataset.slide);
    this.scrollToSlide(slideIndex);
  }

  scrollToSlide(index) {
    this.slider.scrollTo({
      left: this.querySelector(`[id^="Slide-"]:nth-child(${index})`).offsetLeft,
      behavior: 'smooth'
    });
  }

  update() {
    const items = this.querySelectorAll('[id^="Slide-"]');
    const scrollLeft = this.slider.scrollLeft;
    const scrollWidth = this.slider.scrollWidth;
    const clientWidth = this.slider.clientWidth;
    const blockWidth = items[0]?.offsetWidth ?? 0;
    const gap = window.innerWidth < 750 ? 16 : 24;
    const hasScroll = this.slider.scrollWidth > clientWidth;
      
    this.maxLength = items.length - (Math.floor(clientWidth / blockWidth) - 1);
    this.currentSlide = Math.round(scrollLeft / (blockWidth + gap)) + 1;
    
    if (this.prevButton && this.nextButton) {
      this.prevButton.toggleAttribute("disabled", this.currentSlide == 1);
      this.nextButton.toggleAttribute("disabled", this.currentSlide == this.maxLength);
  
      if (this.hideControls) {
        this.prevButton.classList.toggle("hidden", !hasScroll);
        this.nextButton.classList.toggle("hidden", !hasScroll);
      }
    }

    if (this.scrollbarThumb) {      
      const thumbWidth = (clientWidth / scrollWidth) * 100;
      const thumbPosition = (scrollLeft / (scrollWidth - clientWidth)) * 100;

      this.scrollbarThumb.style.left = `${thumbPosition}%`;
      this.scrollbarThumb.style.width = `${thumbWidth}%`;
      this.scrollbarThumb.style.transform = `translateX(-${thumbPosition}%)`;
      this.scrollbar.classList.toggle("hidden", !hasScroll);
    }

    if (this.pagination) {
      this.updatePagination();
    }
  
    if (this.allowEvents) {
      this.dispatchEvent(
        new CustomEvent("slider-updated", {
          detail: {
            currentSlide: this.currentSlide
          },
          bubbles: true,
        })
      );
    }
  }

  updatePagination() {
    const slides = this.querySelectorAll('[id^="Slide-"]');

    if (!this.slider || slides.length === 0 || !this.pagination) return;

    const containerWidth = this.slider.clientWidth;
    const slideWidth = slides[0].offsetWidth;

    const slidesPerPage = Math.floor(containerWidth / slideWidth);
    const totalPages = slides.length - (slidesPerPage - 1);

    this.pagination.innerHTML = '';
    this.pagination.classList.toggle("hidden", totalPages === 1);

    for (let i = 1; i <= totalPages; i++) {
      const dot = document.createElement('span');
      dot.setAttribute("data-slide", i);
      if (i === this.currentSlide) dot.classList.add("active");
      this.pagination.appendChild(dot);
    }
  }
}

customElements.define("slider-component", SliderComponent);

class CustomSubscritpion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.form = this.querySelector("form");
    this.submitButton = this.querySelector('[type="submit"]');

    this.toggleOption();
    this.form?.addEventListener("change", this.toggleOption.bind(this));
    this.form?.addEventListener("submit", this.onFormSubmit.bind(this));
  }

  toggleOption() {
    const currentOption = this.querySelector("input:checked");

    this.querySelector("[name='selling_plan']").value = currentOption.value;
    this.submitButton.querySelector("[data-price]").textContent = currentOption.dataset.price;
  }

  onFormSubmit(event) {
    event.preventDefault();

    this.dispatchEvent(
      new CustomEvent("subscription-submit", {bubbles: true})
    );
  }
}

customElements.define("custom-subscription", CustomSubscritpion);

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
  }

  connectedCallback() {
    this.initClickEvents();

    document.addEventListener("click", (e) => {
      if (e.target.hasAttribute("cart-drawer-toggle")) {
        this.open();
      }
    })
  }

  updateQuantity(item, quantity, itemEl = false) {
    this.toggleLoading(itemEl);
    
    const data = {
      line: item,
      quantity: quantity,
      sections: ["cart-drawer"],
      sections_url: window.location.pathname
    }

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(response => {
      if (response.sections) {
        this.renderContent(response.sections);
      } else {
        throw new Error(response.description);
      }
    })
    .catch((error) => {
      const itemEl = this.querySelector(`[data-item="${item}"]`);
      const messageBlock = itemEl.querySelector("[item-notification]");

      console.error('Error:', error);

      messageBlock.innerText = error.message;
      setTimeout(() => {messageBlock.innerText = ""}, 5000);
    })
    .finally(() => {this.toggleLoading(itemEl)});
  }

  renderContent(sections) {
    if (!sections['cart-drawer']) return;

    const html = new DOMParser().parseFromString(sections['cart-drawer'], "text/html");
    const newCartDrawer = html.querySelector("cart-drawer");
    
    this.querySelector("[js-content]").innerHTML = newCartDrawer.querySelector("[js-content]").innerHTML;
    this.setAttribute("data-count", newCartDrawer.dataset.count);

    document.querySelectorAll("[cart-item-count]").forEach(countEl => countEl.innerText = newCartDrawer.dataset.count);
  }

  initClickEvents() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-action")) {
        e.preventDefault();
  
        const item = e.target.closest("[data-item]");
        const itemQuantityInput = item?.querySelector('[name="quantity"]') ?? false;
        const itemQuantity = parseInt(itemQuantityInput?.value) ?? false;
  
        switch (e.target.dataset.action) {
          case "close":
            this.close();
            break;
          case "remove-item":
            if (!this.isLoading) {
              this.updateQuantity(parseInt(item.dataset.item), 0);
            }
            break;
          case "decrease-quantity":          
            if (itemQuantity > 1) {
              if (!this.isLoading) {
                this.updateQuantity(parseInt(item.dataset.item), parseInt(itemQuantity - 1), item);
              }
            }
            break;
          case "increase-quantity":
            if (itemQuantity < 199) {
              if (!this.isLoading) {
                this.updateQuantity(parseInt(item.dataset.item), parseInt(itemQuantity + 1), item);
              }
            }
            break;
        }
      }
    })
  }

  toggleLoading(itemEl) {
    this.isLoading = !this.isLoading;
    this.classList.toggle("loading-item", this.isLoading);

    if (itemEl) {
      itemEl.classList.toggle("loading", this.isLoading);
    }
  }

  open() {
    this.classList.add("open");
    document.documentElement.style.overflow = "hidden";
  }

  close() {
    this.classList.remove("open");
    document.documentElement.style.overflow = null;
  }
}

if (document.querySelector("cart-drawer")) {
  customElements.define("cart-drawer", CartDrawer);
}

class ProductQuickAdd extends HTMLElement {
  constructor () {
    super();
  }

  connectedCallback() {
    this.isLoading = false;
    this.cart = document.querySelector("cart-drawer");
    this.contentContainer = this.querySelector("[data-content]");

    this.initClickEvents();
  }

  initQuickAdd(target) {
    if (!target && target.dataset.path) return;
    
    this.close();
    this.toggleLoading();

    fetch(target.dataset.path)
    .then(res => res.text())
    .then(body => {
      const html = new DOMParser().parseFromString(body, "text/html");
      const quickAddContent = html.querySelector("[data-quick-content]");

      this.contentContainer.innerHTML = quickAddContent.innerHTML;
    })
    .catch(error => console.error(error))
    .finally(() => {
      this.open();
      this.toggleLoading();
      
      target.classList.remove("loading");
    })
  }

  onFormSubmit(event = false) {
    if (event) event.preventDefault();

    if (this.isLoading) return;

    const sections = [];
    if (this.cart) sections.push("cart-drawer");

    const cartData = {
      items: [
        {
          id: parseInt(this.querySelector("[name='id']").value),
          quantity: parseInt(this.querySelector("[name='quantity']").value),
          selling_plan: parseInt(this.querySelector("[name='selling_plan']").value)
        }
      ],
      sections: sections,
      sections_url: window.location.pathname
    };

    this.addToCart(cartData);
  }

  addToCart(data) {
    if (!data) return;

    this.toggleLoading();

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then(response => {
      if (!response.items) {
        const error = new Error(response.description);
        throw error;
      } else {
        this.close();
        
        if (this.cart) {
          this.cart.renderContent(response.sections);
          this.cart.open();
        }
      }
    })
    .catch(error => this.showError(error))
    .finally(() => this.toggleLoading(true));
  }

  initClickEvents() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-action")) {
        switch (e.target.dataset.action) {
          case "add-once":
            this.querySelector("[name='selling_plan']").value = "";
            this.onFormSubmit();
            break;
          case "close":
            this.close();
            break;
        }
      }
    })

    document.addEventListener("click", (e) => {
      if (e.target.hasAttribute("js-quick-view") && !this.isLoading) {
        this.initQuickAdd(e.target);
      }
    })

    this.addEventListener("subscription-submit", () => {
      this.onFormSubmit();
    })
  }

  showError(error) {
    console.error(error);

    if (!this.querySelector("[product-notification]")) return;

    const messageBlock = this.querySelector("[product-notification]");

    messageBlock.innerText = error.message;
    setTimeout(() => {messageBlock.innerText = ''}, 5000);
    messageBlock.scrollIntoView({behavior: "smooth",block:"center"});
  }

  close() {
    this.classList.remove("open");
    document.documentElement.style.overflow = null;
  }

  open() {
    this.classList.add("open");
    document.documentElement.style.overflow = "hidden";
  }

  toggleLoading(turnOff = false) {
    this.isLoading = !this.isLoading;
    if (turnOff) this.isLoading = false;
    this.classList.toggle("loading", this.isLoading);
  }
}

if (document.querySelector("product-quick-add")) {
  customElements.define("product-quick-add", ProductQuickAdd);
}